import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { HOME_CHEF, BrandContext } from 'context/BrandContext';
import { generateRandomEmail, generateChicagoPhoneNumber } from 'helpers/internalSkipFunctions';
import { getBrandRoute, PICK_MEALS_MENU_PATH } from 'helpers/routes';
import useBrand from 'hooks/useBrand';
import { STANDARD, TEMPO, FAMILY } from 'lib/constants';
import { SKIP_PATHS } from 'lib/constants/signUp';

export const NAVIGATION_MODE = {
  HISTORY: 'history',
  DOCUMENT: 'document',
  SLIDEOUT: 'slideout',
};

const useInternalSkip = (mealPlanSlug, { onSlideOutNavigate } = {}) => {
  const { brand } = useContext(BrandContext);
  const [isInternalVisible, setIsInternalVisible] = useState(false);
  const isHomeChef = useBrand(HOME_CHEF);
  const navigate = useNavigate();

  const isFamilyMealPlan = mealPlanSlug === FAMILY;
  const brandRoutes = getBrandRoute({ brand, isFamily: isFamilyMealPlan });

  const internalValues = () => ({
    introZipCode: '60607',
    introEmail: generateRandomEmail(),
    introSmsOptIn: false,
    introSmsPhoneNumber: generateChicagoPhoneNumber(),
    mealPlanSlug: isHomeChef ? STANDARD : TEMPO,
  });

  const pathMap = {
    [SKIP_PATHS.PREF_DIETARY]: brandRoutes.preferenceDietary,
    [SKIP_PATHS.PROMO]: brandRoutes.promo,
    [SKIP_PATHS.BOX_PEOPLE]: brandRoutes.boxRecommenderPeople,
    [SKIP_PATHS.BOX]: brandRoutes.box,
    [SKIP_PATHS.BILLING]: brandRoutes.billing,
    [SKIP_PATHS.THANK_YOU]: brandRoutes.thankyou,
    [SKIP_PATHS.PICK_MEALS]: brandRoutes.pickMeals,
    [SKIP_PATHS.PICK_MEALS_BILLING]: brandRoutes.pickMealsBilling,
    [SKIP_PATHS.PICK_MEALS_THANK_YOU]: brandRoutes.pickMealsThankYou,
    [SKIP_PATHS.INTRO]: brandRoutes.intro,
  };

  const slideOutPaths = [SKIP_PATHS.PREF_DIETARY, SKIP_PATHS.BOX_PEOPLE, SKIP_PATHS.BOX];

  const handlePath = to => {
    if (onSlideOutNavigate && slideOutPaths.includes(to)) {
      onSlideOutNavigate(to);
      return NAVIGATION_MODE.SLIDEOUT;
    }

    const path = pathMap[to];
    if (path) {
      const isOutsideReactNavigation =
        path.startsWith(PICK_MEALS_MENU_PATH) &&
        !window.location.pathname.startsWith(PICK_MEALS_MENU_PATH);

      if (isOutsideReactNavigation) {
        window.location.href = path;
        return NAVIGATION_MODE.DOCUMENT;
      }

      navigate(path);
      return NAVIGATION_MODE.HISTORY;
    } else {
      // eslint-disable-next-line no-console
      console.error(`Skip Tool handlePath: Unknown path '${to}'`);
    }

    return null;
  };

  return {
    generateRandomEmail,
    internalValues,
    handlePath,
    isInternalVisible,
    setIsInternalVisible,
  };
};

export default useInternalSkip;
